import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { CallHistoryPage } from "@/features/incoming-calls/pages/call-history-page";
import { callHistoryFilterSchema } from "@/features/incoming-calls/schemas/call-history-filter.schema";

export const Route = createFileRoute("/_authenticated/calls/history")({
	component: CallHistoryPage,
	validateSearch: zodValidator(callHistoryFilterSchema),
});
